import { apiV1 } from './api';
import { encodeQueryArray } from '../utils';

const searchQuery = (search = {}, isFilterDisabled, includeStatus = true) =>
  `by_keywords=${search.keywords || ''}&by_delay=${search.delay || ''}${
    includeStatus ? `&by_status=${search.status || ''}` : ''
  }&by_company=${search.company?.value || search.companyId || ''}&by_department=${search.department
    ?.value ||
    search.department ||
    ''}${encodeQueryArray('by_tags', search.tags || [])}${encodeQueryArray(
    'by_stages',
    search.stages || [],
  )}${encodeQueryArray(
    'by_characteristics',
    search.characteristics || [],
  )}&ignore_operator_filter=${isFilterDisabled}`;

const getQuotes = (page = 1, search = {}, isFilterDisabled) =>
  apiV1
    .get(
      `/quote_request_summaries?page=${page}&${searchQuery(
        search,
        isFilterDisabled,
      )}&include_dashboard=false${search.sort ? `&sort=${search.sort}` : ''}`,
    )
    .then(({ data }) => data);

const getDashboard = (search = {}, isFilterDisabled) =>
  apiV1
    .get(`/quote_request_summaries/dashboard?${searchQuery(search, isFilterDisabled, false)}`)
    .then(({ data }) => data);

const uploadQuoteFile = (quoteRequestId, quote) =>
  apiV1
    .post(`/quote_request_summaries/${quoteRequestId}/upload_quote`, quote, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(({ data }) => data);

export const quotesAPI = {
  getQuotes,
  getDashboard,
  uploadQuoteFile,
};
